/* Extracted from snippets/cart-drawer.liquid (lines 2728-3423 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
(function() {
  'use strict';
  
  var LIST = 'cart_upsell';
  var HEADING_DEFAULT = 'Complete your routine';
  var HEADING_SWAP = "Better value on what you're buying";

  
  function whenRecs() {
    var TC = window.TheColor || {};
    if (TC.Recs) return Promise.resolve(TC.Recs);
    return new Promise(function(resolve) {
      var t = setTimeout(function() { resolve(null); }, 15000);
      document.addEventListener('recs:ready', function() {
        clearTimeout(t);
        resolve((window.TheColor || {}).Recs || null);
      }, { once: true });
    });
  }

  
  var lastCart = null;
  document.addEventListener('cart:updated', function(e) {
    lastCart = (e.detail && e.detail.cart) || null;
    
    if (!committed.length) return;
    var R = (window.TheColor || {}).Recs;
    if (lastCart && R && R.sig(lastCart) === committedSig) return;
    setStale(true);
  });
  
  function getCart() {
    if (lastCart) return Promise.resolve(lastCart);
    var TC = window.TheColor || {};
    var p = (TC.Cart && TC.Cart.current) ? TC.Cart.current()
      : (TC.Recs && TC.Recs.getCart) ? TC.Recs.getCart()
      : fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
    return Promise.resolve(p).then(function(c) { if (c && c.items) lastCart = c; return c; });
  }

  
  function getDismissed() {
    var R = (window.TheColor || {}).Recs;
    if (R) return R.dismissed();
    try {
      var raw = sessionStorage.getItem('tc-upsell-dismissed');
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function addDismissed(card) {
    var R = (window.TheColor || {}).Recs;
    if (R) R.dismiss(card.productId, card.handle);
  }

  function freeShippingCodes() {
    return (window.theme && window.theme.freeShippingCodes) || [];
  }

  
  var committed = [];        
  var committedSig = null;   
  var stale = false;         

  
  function setStale(on) {
    stale = !!on;
    document.querySelectorAll('[data-cart-upsell]').forEach(function(w) {
      w.classList.toggle('is-stale', stale);
      if (stale) w.setAttribute('aria-busy', 'true');
      else w.removeAttribute('aria-busy');
    });
  }

  function esc(s) { return window.TheColor.Recs.escapeHtml(s); }
  function money(p) { return window.TheColor.Recs.money(p); }

  function displayName(card) {
    return String(card.title || '')
      .replace(/^Paul Mitchell\s+/i, '')
      .replace(/\s+—\s+Salon Stockpile.*$/i, '');
  }

  function optionLabel(o) {
    return (o.sizeLabel || 'One size') + ', ' + money(o.price) +
      (o.crossesGap ? ', adds free delivery' : '') + (o.travel ? ', travel size' : '');
  }

  function addLabel(card, o) {
    if (card.kind === 'swap') {
      return 'Swap to ' + card.title + (o.sizeLabel ? ', ' + o.sizeLabel : '') + ', ' +
        money(o.price * (card.qty || 1)) + ', ' + (card.note || '').replace(/^Replaces/, 'replacing');
    }
    return 'Add ' + card.title + (o.sizeLabel ? ', ' + o.sizeLabel : '') + ', ' + money(o.price) + ', to basket';
  }

  function chipsHtml(chips) {
    return (chips || []).map(function(c) {
      return c === 'Adds free delivery'
        ? '<span class="tc-upsell-chip tc-upsell-chip--delivery"><span aria-hidden="true">&#10003;</span>' + esc(c) + '</span>'
        : '<span class="tc-upsell-chip">' + esc(c) + '</span>';
    }).join('');
  }

  
  function ratingHtml(card) {
    if (!card.rating || !(card.ratingCount >= 3)) return '';
    return '<span class="tc-cart-drawer__upsell-rating">' +
      '<span class="tc-cart-drawer__upsell-rating-star" aria-hidden="true">&#9733;</span>' +
      '<strong aria-hidden="true">' + esc(card.rating.toFixed(1)) + '</strong>' +
      '<span aria-hidden="true">(' + esc(String(card.ratingCount)) + ')</span>' +
      '<span class="tc-sr-only">Rated ' + esc(card.rating.toFixed(1)) + ' out of 5 from ' + esc(String(card.ratingCount)) + ' reviews</span>' +
    '</span>';
  }

  
  function sizeLine(card, o) {
    if (card.kind === 'swap') return (card.qty > 1 ? card.qty + ' × ' : '') + (o.sizeLabel || '');
    return card.options.length > 1 ? (o.unitPrice || '') : (o.sizeLabel || '');
  }

  function cardHtml(card, i) {
    var o = card.options[0];
    var isSwap = card.kind === 'swap';
    var url = esc(card.url);
    var sizes = '';
    if (card.options.length > 1) {
      sizes = '<div class="tc-cart-drawer__upsell-sizes" role="radiogroup" aria-label="Size">' +
        card.options.map(function(op, k) {
          return '<button type="button" role="radio" class="tc-cart-drawer__upsell-size-opt" data-upsell-size="' + k + '"' +
            ' aria-checked="' + (k === 0 ? 'true' : 'false') + '" tabindex="' + (k === 0 ? '0' : '-1') + '"' +
            ' aria-label="' + esc(optionLabel(op)) + '">' + esc(op.sizeLabel || 'One size') +
            ' <span>' + esc(money(op.price)) + '</span></button>';
        }).join('') + '</div>';
    }
    return '<li class="tc-cart-drawer__upsell-card' + (isSwap ? ' tc-cart-drawer__upsell-card--swap' : '') + '"' +
        ' data-upsell-card data-index="' + i + '" data-handle="' + esc(card.handle) + '" data-kind="' + esc(card.kind) + '">' +
      '<a class="tc-cart-drawer__upsell-media" href="' + url + '" tabindex="-1" aria-hidden="true" data-upsell-select>' +
        (o.image ? '<img class="tc-cart-drawer__upsell-img" src="' + esc(o.image) + '" alt="" width="76" height="76" loading="lazy" data-upsell-img>' : '') +
      '</a>' +
      '<div class="tc-cart-drawer__upsell-info">' +
        '<p class="tc-cart-drawer__upsell-reason">' + esc(card.reason) + '</p>' +
        '<a class="tc-cart-drawer__upsell-title" href="' + url + '" title="' + esc(card.title) + '" data-upsell-select>' + esc(displayName(card)) + '</a>' +
        ratingHtml(card) +
        (isSwap && card.note ? '<p class="tc-cart-drawer__upsell-note">' + esc(card.note) + '</p>' : '') +
        sizes +
        '<div class="tc-cart-drawer__upsell-buy">' +
          '<p class="tc-cart-drawer__upsell-meta">' +
            '<span class="tc-cart-drawer__upsell-size" data-upsell-sizeline>' + esc(sizeLine(card, o)) + '</span>' +
            '<span class="tc-cart-drawer__upsell-price" data-upsell-price>' + esc(money(o.price * (isSwap ? (card.qty || 1) : 1))) + '</span>' +
          '</p>' +
          '<button type="button" class="tc-cart-drawer__upsell-add" data-upsell-add="' + esc(o.variantId) + '" aria-label="' + esc(addLabel(card, o)) + '">' +
            (isSwap ? 'Swap' : '+ Add') + '</button>' +
        '</div>' +
        '<p class="tc-cart-drawer__upsell-chips" data-upsell-chips' + (o.chips.length ? '' : ' hidden') + '>' + chipsHtml(o.chips) + '</p>' +
      '</div>' +
      '<button type="button" class="tc-cart-drawer__upsell-dismiss" data-upsell-dismiss aria-label="' + esc('Hide suggestion: ' + card.title) + '">&times;</button>' +
    '</li>';
  }

  
  function renderUpsellCards(container, cards) {
    var wrap = container.closest('[data-cart-upsell]');
    if (wrap) wrap.style.display = cards.length ? '' : 'none';
    container.innerHTML = cards.length ? cards.map(cardHtml).join('') : '';
    if (cards.length) {
      container.scrollLeft = 0;
      refreshScroller(container);
    }
  }

  function refreshScroller(track) {
    var root = track.closest('[data-tc-scroller]');
    var S = (window.TheColor || {}).Scroller;
    if (!root || !S) return;
    try {
      if (typeof S.refresh === 'function') S.refresh(root);
      else if (typeof S.init === 'function') S.init(root);
    } catch (e) {  }
    try { track.dispatchEvent(new Event('scroll')); } catch (e) {}
  }

  
  function setHeadings() {
    var swapOnly = committed.length > 0 && committed.every(function(c) { return c.kind === 'swap'; });
    document.querySelectorAll('.tc-cart-drawer__upsell-heading').forEach(function(h) {
      h.textContent = swapOnly ? HEADING_SWAP : HEADING_DEFAULT;
    });
  }

  function paintAll() {
    document.querySelectorAll('[data-cart-upsell-products]').forEach(function(c) {
      renderUpsellCards(c, committed);
    });
    setHeadings();
    observeStrips();
    requestAnimationFrame(checkViews);
  }

  
  function repaintWiped() {
    if (committedSig !== lastUpsellSig) return;   
    
    if (stale) setStale(false);
    document.querySelectorAll('[data-cart-upsell-products]').forEach(function(c) {
      if (!c.querySelector('[data-upsell-card]') && committed.length) renderUpsellCards(c, committed);
    });
    setHeadings();
    observeStrips();
    requestAnimationFrame(checkViews);
    scheduleUpgrades();
  }

  function hideAll() {
    committed = [];
    committedSig = null;
    setStale(false);
    document.querySelectorAll('[data-cart-upsell-products]').forEach(function(c) {
      renderUpsellCards(c, []);
    });
  }

  
  
  var lastUpsellSig = null;
  var upsellToken = 0;
  var warnedFail = false;

  
  var retryPending = false;

  function loadUpsellProducts() {
    if (!document.querySelector('[data-cart-upsell-products]')) return;
    
    whenRecs().then(function(R) { if (R && R.warmGraph) R.warmGraph(); });
    getCart().then(function(cart) {
      if (!cart || !cart.item_count) {
        hideAll();
        lastUpsellSig = null;
        
        upsellToken++;
        return;
      }
      return whenRecs().then(function(R) {
        if (!R) return;
        var sig = R.sig(cart);
        if (sig === lastUpsellSig) { repaintWiped(); return; }
        lastUpsellSig = sig;
        var myToken = ++upsellToken;
        return R.forCart(cart, { dismissed: getDismissed(), freeShippingCodes: freeShippingCodes() })
          .then(function(cards) {
            if (cards && cards.incomplete && !cards.length) {
              
              if (myToken === upsellToken) lastUpsellSig = null;
              retryPending = true;
            } else if (myToken === upsellToken) {
              retryPending = !!(cards && cards.incomplete);
              if (retryPending) lastUpsellSig = null;
            }
            commit(cards, myToken, sig);
          });
      });
    }).catch(function(err) {
      lastUpsellSig = null;   
      
      if (stale) hideAll();
      if (!warnedFail) {
        warnedFail = true;
        if (window.console && console.warn) console.warn('[cart upsell] unavailable:', err && err.message);
      }
    });
  }

  function commit(cards, myToken, sig) {
    if (myToken !== upsellToken) return;   
    
    if (!document.querySelector('[data-cart-item-id]')) return;
    committed = cards || [];
    committedSig = sig;
    setStale(false);
    
    paintAll();
    scheduleUpgrades();
  }

  
  
  var upgradeTimer = null;
  var upgradeToken = 0;
  var upgradeCache = {};   

  function scheduleUpgrades() {
    clearTimeout(upgradeTimer);
    upgradeTimer = setTimeout(fillUpgrades, 150);
  }

  function fillUpgrades() {
    var slots = document.querySelectorAll('[data-line-upgrade]');
    if (!slots.length) return;
    var my = ++upgradeToken;
    Promise.all([whenRecs(), getCart()]).then(function(res) {
      var R = res[0], cart = res[1];
      if (!R || !R.upgradeFor || !cart || !cart.items || !cart.items.length) return;
      var byKey = {};
      cart.items.forEach(function(it) { byKey[it.key] = it; });
      
      var owned = cart.items.map(function(it) { return it.variant_id; }).sort().join(',');
      var keys = {};
      Array.prototype.forEach.call(slots, function(sl) { keys[sl.getAttribute('data-key')] = true; });
      return Promise.all(Object.keys(keys).map(function(k) {
        var it = byKey[k];
        if (!it) return Promise.resolve([k, null, null]);
        var ck = k + '|' + it.quantity + '|' + it.price + '|' + owned;
        if (Object.prototype.hasOwnProperty.call(upgradeCache, ck)) return Promise.resolve([k, it, upgradeCache[ck]]);
        return R.upgradeFor(it, cart).then(function(up) {
          upgradeCache[ck] = up;
          return [k, it, up];
        }, function() { return [k, it, undefined]; });
      })).then(function(rows) {
        if (my !== upgradeToken) return;
        
        rows.forEach(function(r) { if (r[2] !== undefined) paintUpgrade(r[0], r[1], r[2]); });
      });
    }).catch(function() {});
  }

  function paintUpgrade(key, item, up) {
    document.querySelectorAll('[data-line-upgrade]').forEach(function(sl) {
      if (sl.getAttribute('data-key') !== key) return;
      if (!up || !item) { sl.hidden = true; sl.textContent = ''; return; }
      var label = 'Upgrade to ' + up.sizeLabel;
      var nowUnit = String(up.unitNow).split('/')[0];
      var each = item.quantity > 1 ? ' each' : '';
      sl.innerHTML = '<button type="button" class="tc-cart-line-upgrade__btn" data-upgrade-variant="' + esc(up.variantId) + '"' +
        ' data-upgrade-key="' + esc(key) + '" data-upgrade-qty="' + esc(item.quantity) + '"' +
        ' aria-label="' + esc(label + ', ' + money(up.price) + each + ': ' + up.unitNew + ' instead of ' + up.unitNow) + '">' +
        esc(label) + '</button> · ' + esc(money(up.price) + each) + ' (' + esc(up.unitNew) + ' vs ' + esc(nowUnit) + ')';
      sl.hidden = false;
    });
  }

  document.addEventListener('click', function(e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-upgrade-variant]') : null;
    if (!b || b.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    var Cart = (window.TheColor || {}).Cart;
    if (!Cart || !Cart.applyUpdates) return;
    var key = b.getAttribute('data-upgrade-key');
    var vid = b.getAttribute('data-upgrade-variant');
    var qty = parseInt(b.getAttribute('data-upgrade-qty'), 10) || 1;
    var updates = {};
    updates[key] = 0;
    updates[vid] = qty;
    var label = b.textContent;
    var inDrawer = !!b.closest('[data-cart-drawer]');
    
    b.setAttribute('aria-disabled', 'true');
    b.textContent = 'Upgrading…';
    Cart.applyUpdates(updates, { list: 'cart_upgrade', reason: 'upgrade' }).then(function() {
      
      if (inDrawer) {
        var row = document.querySelector('[data-cart-drawer] [data-variant-id="' + vid + '"]');
        var t = row && row.querySelector('[data-quantity-input]');
        if (t) t.focus({ preventScroll: true });
      }
    }).catch(function() {
      if (b.isConnected) { b.removeAttribute('aria-disabled'); b.textContent = label; }
    });
  });

  
  function cardFor(el) {
    var li = el.closest('[data-upsell-card]');
    if (!li) return null;
    var idx = parseInt(li.getAttribute('data-index'), 10);
    var card = committed[idx];
    if (!card || card.handle !== li.getAttribute('data-handle')) return null;
    return { li: li, idx: idx, card: card };
  }

  function selectedOption(li, card) {
    var k = parseInt(li.getAttribute('data-selected') || '0', 10);
    return card.options[k] || card.options[0];
  }

  
  function selectSize(li, card, k, focus) {
    var o = card.options[k];
    if (!o) return;
    li.setAttribute('data-selected', String(k));
    li.querySelectorAll('[data-upsell-size]').forEach(function(b, j) {
      b.setAttribute('aria-checked', j === k ? 'true' : 'false');
      b.tabIndex = j === k ? 0 : -1;
      if (j === k && focus) b.focus();
    });
    var price = li.querySelector('[data-upsell-price]');
    if (price) price.textContent = money(o.price);
    var line = li.querySelector('[data-upsell-sizeline]');
    if (line) line.textContent = sizeLine(card, o);
    var chips = li.querySelector('[data-upsell-chips]');
    if (chips) { chips.innerHTML = chipsHtml(o.chips); chips.hidden = !o.chips.length; }
    var add = li.querySelector('[data-upsell-add]');
    if (add) { add.setAttribute('data-upsell-add', String(o.variantId)); add.setAttribute('aria-label', addLabel(card, o)); }
    var img = li.querySelector('[data-upsell-img]');
    if (img && o.image) img.src = o.image;
  }

  function announce(from, msg) {
    var wrap = from && from.closest ? from.closest('[data-cart-upsell]') : null;
    var live = wrap && wrap.querySelector('[data-upsell-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function() { live.textContent = msg; }, 60);
  }

  
  function keepUpsellFocus(strip, idx, btn) {
    if (!strip || typeof MutationObserver !== 'function') return;
    var wrap = strip.closest('[data-cart-upsell]');
    var mo = new MutationObserver(check);
    function check() {
      if (btn.isConnected) return;
      mo.disconnect();
      var a = document.activeElement;
      if (a && a !== document.body && a !== document.documentElement) return;
      var cards = strip.querySelectorAll('[data-upsell-card]');
      var next = cards[idx] || cards[cards.length - 1];
      var target = next && next.querySelector('[data-upsell-add]');
      if (!target && wrap && wrap.style.display !== 'none') target = wrap.querySelector('.tc-cart-drawer__upsell-heading');
      if (target && !target.getClientRects().length) target = null;
      if (!target) {
        var d = strip.closest('[data-cart-drawer]');
        target = d ? d.querySelector('[data-action="close-cart"]') : (wrap && wrap.closest('[data-section-type="cart-main"]') ? document.querySelector('[data-cart-summary-heading]') : null);
        if (target && !target.hasAttribute('tabindex') && target.tagName !== 'BUTTON') target.setAttribute('tabindex', '-1');
      }
      if (target) target.focus({ preventScroll: true });
    }
    mo.observe(strip, { childList: true, subtree: true });
    setTimeout(function() { mo.disconnect(); }, 10000);
  }

  function onAdd(hit, btn) {
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var R = window.TheColor.Recs;
    var card = hit.card;
    var o = selectedOption(hit.li, card);
    var label = btn.textContent;
    var strip = hit.li.closest('[data-cart-upsell-products]');
    
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = card.kind === 'swap' ? 'Swapping…' : 'Adding…';
    keepUpsellFocus(strip, hit.idx, btn);
    function restore() {
      if (!btn.isConnected) return;
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
    }
    
    function settle() { setTimeout(restore, 4000); }
    var ctx = R.listContext(LIST, card, hit.idx, o);
    var Cart = window.TheColor && window.TheColor.Cart;

    if (card.kind === 'swap') {
      var run = (Cart && Cart.applyUpdates)
        ? Cart.applyUpdates(card.updates, ctx)
        : fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: card.updates })
          }).then(function(r) {
            if (!r.ok) throw new Error('swap failed: ' + r.status);
            if (Cart && Cart.init) Cart.init();
            return r.json();
          });
      run.then(function() {
        announce(strip, 'Swapped to ' + card.title + ', saving ' + money(card.saving));
        settle();
      }).catch(restore);
      return;
    }

    if (Cart && Cart.addToCart) {
      
      Cart.addToCart(o.variantId, 1, {}, ctx).then(function() {
        announce(strip, 'Added ' + card.title);
        settle();
      }).catch(restore);
    } else {
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: o.variantId, quantity: 1 })
      }).then(function(r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        location.reload();
      }).catch(restore);
    }
  }

  
  function onDismiss(hit) {
    var R = window.TheColor.Recs;
    var card = hit.card;
    var strip = hit.li.closest('[data-cart-upsell-products]');
    var wrap = hit.li.closest('[data-cart-upsell]');
    addDismissed(card);
    R.track.dismiss(LIST, card);
    var myToken = upsellToken;
    var survivors = committed.map(function(c, i) { return i === hit.idx ? null : c; });
    getCart().then(function(cart) {
      return R.forCart(cart, { dismissed: getDismissed(), freeShippingCodes: freeShippingCodes() });
    }).then(function(fresh) {
      
      if (myToken !== upsellToken || stale) return;
      var used = {}, slots = {};
      survivors.forEach(function(c) { if (c) { used[c.handle] = true; slots[c.slot] = true; } });
      var fill = (fresh || []).filter(function(c) { return !used[c.handle] && !slots[c.slot]; });
      committed = survivors.map(function(c) { return c || fill.shift() || null; }).filter(Boolean);
      paintAll();
      var cards = strip ? strip.querySelectorAll('[data-upsell-card]') : [];
      var next = cards[hit.idx] || cards[cards.length - 1];
      var target = next && next.querySelector('[data-upsell-add]');
      if (!target && wrap) target = wrap.querySelector('.tc-cart-drawer__upsell-heading');
      if (target && wrap && wrap.style.display === 'none') target = null;
      if (target) target.focus();
    }).catch(function() {
      
      if (stale) return;
      committed = survivors.filter(Boolean);
      paintAll();
    });
  }

  
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-cart-upsell-products]')) return;
    var hit = cardFor(t);
    if (!hit) return;
    var sel = t.closest('[data-upsell-select]');
    if (sel) {
      window.TheColor.Recs.track.selectItem(LIST, hit.card, hit.idx, selectedOption(hit.li, hit.card));
      return;   
    }
    var size = t.closest('[data-upsell-size]');
    if (size) { e.preventDefault(); selectSize(hit.li, hit.card, parseInt(size.getAttribute('data-upsell-size'), 10), false); return; }
    var add = t.closest('[data-upsell-add]');
    if (add) { e.preventDefault(); onAdd(hit, add); return; }
    if (t.closest('[data-upsell-dismiss]')) { e.preventDefault(); onDismiss(hit); }
  });

  
  document.addEventListener('keydown', function(e) {
    var t = e.target;
    if (!t || !t.closest || !t.matches || !t.matches('[data-upsell-size]')) return;
    var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0);
    if (!dir) return;
    var hit = cardFor(t);
    if (!hit) return;
    e.preventDefault();
    var n = hit.card.options.length;
    var k = (parseInt(t.getAttribute('data-upsell-size'), 10) + dir + n) % n;
    selectSize(hit.li, hit.card, k, true);
  });

  
  
  var viewed = {};
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries) {
    entries.forEach(function(en) { en.target._tcRatio = en.isIntersecting ? en.intersectionRatio : 0; });
    checkViews();
  }, { threshold: [0, 0.5, 1] }) : null;

  function observeStrips() {
    if (!io) return;
    document.querySelectorAll('[data-cart-upsell]').forEach(function(w) {
      if (!w._tcObserved) { w._tcObserved = true; io.observe(w); }
    });
  }

  function checkViews() {
    
    if (stale || committedSig !== lastUpsellSig) return;
    if (!committed.length || !window.TheColor.Recs) return;
    var key = committed.map(function(c) { return c.handle + ':' + c.variantId; }).join('|');
    if (viewed[key]) return;
    var inView = Array.prototype.some.call(document.querySelectorAll('[data-cart-upsell]'), function(w) {
      if (w.style.display === 'none' || !w.querySelector('[data-upsell-card]')) return false;
      var drawer = w.closest('[data-cart-drawer]');
      if (drawer && !drawer.classList.contains('is-open')) return false;
      return (w._tcRatio || 0) >= 0.5;
    });
    if (inView && window.TheColor.Recs.track.viewList(LIST, committed)) viewed[key] = true;
  }

  
  var upsellTimer = null;
  function scheduleUpsellRefresh() {
    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(loadUpsellProducts, 60);
  }

  
  window.TheColor = window.TheColor || {};
  window.TheColor.Upsell = { refresh: scheduleUpsellRefresh };

  document.addEventListener('cart:open', function() {
    scheduleUpsellRefresh();
    setTimeout(checkViews, 400);   
  });
  document.addEventListener('cart:updated', scheduleUpsellRefresh);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && retryPending && document.querySelector('[data-cart-item-id]')) {
      scheduleUpsellRefresh();
    }
  });
  
  if (document.querySelector('[data-cart-item-id]')) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() { loadUpsellProducts(); }, { timeout: 5000 });
    } else {
      setTimeout(loadUpsellProducts, 3000);
    }
  }
})();
